<form [formGroup]="form" style="position: relative">
  <p-colorPicker
    formControlName="color"
    (onShow)="onColorPickerShow()"
    (onHide)="onColorPickerHide()"
    [appendTo]="'body'"
  ></p-colorPicker>
</form>
